// extracted by mini-css-extract-plugin
export var chip = "_ce-0";
export var filterDropdown = "_ce-5";
export var filterItem = "_ce-6";
export var icon = "_ce-1";
export var removeButton = "_ce-3";
export var removeIcon = "_ce-4";
export var separator = "_ce-2";